import { useEffect, useState } from 'react';

// Global one-shot highlight for the Swap nav item.
// Any component can call `triggerSwapHighlight()` and every nav using
// `useSwapHighlight()` will glow for ~2.5s.
const EVT = 'grx:swap-highlight';
const DURATION_MS = 2500;

export const triggerSwapHighlight = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVT));
  }
};

export const useSwapHighlight = () => {
  const [on, setOn] = useState(false);
  useEffect(() => {
    let timer;
    const handler = () => {
      setOn(true);
      clearTimeout(timer);
      timer = setTimeout(() => setOn(false), DURATION_MS);
    };
    window.addEventListener(EVT, handler);
    return () => {
      window.removeEventListener(EVT, handler);
      clearTimeout(timer);
    };
  }, []);
  return on;
};
